const overseasHomeBannerRouter = {
  title: '首页轮播图管理',
  type: 'view',
  name: 'overseasHomeBannerList',
  route: '/overseas-home-banner/list',
  filePath: 'view/overseas_home_banner/list.vue',
  order: 8,
  inNav: true,
  icon: 'iconfont el-icon-picture-outline',
  permission: ['查询首页轮播图'],
}

export default overseasHomeBannerRouter
